import gql from 'graphql-tag';

export const GET_CREDIT_SUBMISSION_DECLINE_REASONS = gql`
  query GetCreditSubmissionDeclineReasons($accountId: ID!) {
    creditSubmissionDeclineReasons(accountId: $accountId) {
      creditSubmissionDeclineReasonId
      accountId
      category
      label
      isActive
      createdDateTime
      modifiedDateTime
      createdBy
      modifiedBy
    }
  }
`;
